import React, { useRef, useState, useCallback } from 'react';
import { Upload, Loader2 } from 'lucide-react';

function FileDropzone({ onFilesSelected, multiple = true, isUploading = false, label, hint, compact = false }) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = useCallback((files) => {
    if (files && files.length > 0) {
      onFilesSelected(Array.from(files));
    }
  }, [onFilesSelected]);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);
  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFiles(e.dataTransfer.files);
  }, [handleFiles]);

  return (
    <div
      className={`border-2 border-dashed rounded-xl text-center transition-colors ${
        compact ? 'p-6' : 'p-10'
      } ${
        isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
      } ${isUploading ? 'opacity-50 pointer-events-none' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        className="hidden"
        accept=".pdf,.xlsx,.xls,.csv,.doc,.docx,.txt,.png,.jpg,.jpeg"
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = '';
        }}
      />
      <Upload className={`${compact ? 'h-6 w-6' : 'h-8 w-8'} text-gray-400 mx-auto mb-3`} />
      <p className={`${compact ? 'text-sm' : 'text-base'} font-medium text-gray-700 mb-3`}>
        {isUploading ? 'Uploading...' : (label || 'Drag and drop files here')}
      </p>
      {!isUploading && (
        <>
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className={`px-4 py-2 bg-blue-600 text-white ${compact ? 'text-xs' : 'text-sm'} font-medium rounded-md hover:bg-blue-700 transition-colors inline-flex items-center gap-2`}
          >
            <Upload className="h-4 w-4" />
            Choose {multiple ? 'Files' : 'File'}
          </button>
          <p className="text-xs text-gray-400 mt-3">
            {hint || 'Supports PDF, Excel, Word, CSV, TXT, and images'}
          </p>
        </>
      )}
    </div>
  );
}

export default FileDropzone;
